/* Смена режима экрана «Фото» и «Видео» («Без стиля» ↔ стиль, «Из фото · По описанию»): каждый режим — своё приложение сервера
   со своим состоянием формы (черновик, заявка, загрузки, согласие), и тело формы для него собирается заново — это не меняется.
   Меняется показ: прежнее тело стоит на месте (заблокированное, как на время переключения) до готовности нового,
   новое собирается скрытым и встаёт на его место, когда его форма пришла. Без пустого кадра «Загружаем…», без пропадающей шапки
   и без повторного въезда кнопки «Создать» — как renderBody шаблона на месте (assets/bot-photo.js). */
import { createContext, useCallback, useRef, useState } from 'react';

/** Тело формы заменило прежнее на том же экране: кнопка «Создать» уже стоит, повторный въезд (fin) не нужен */
export const ModeReplacedContext = createContext(false);

export interface HeldBody<T extends { id: number }, S> {
  app: T;
  seed: S;
  visible: boolean;
  /** Тело пришло на смену прежнему на этом экране */
  replaced: boolean;
}

export function useHeldMode<T extends { id: number }, S>(active: T, seed: S) {
  const [shown, setShown] = useState(active);
  const first = useRef(active.id);
  /* у каждого тела свой первый вход: прежнему не подменяется seed нового режима (его форма не перезагружается) */
  const seeds = useRef(new Map<number, S>());
  const last = useRef<number | null>(null);
  if (last.current !== active.id) {
    seeds.current.set(active.id, seed);
    last.current = active.id;
  }
  const ready = useCallback(
    (id: number) => {
      if (id === active.id && shown.id !== active.id) setShown(active);
    },
    [active, shown.id],
  );
  const list = shown.id === active.id ? [active] : [shown, active];
  const bodies: HeldBody<T, S>[] = list.map(app => ({
    app,
    seed: seeds.current.get(app.id) as S,
    visible: app.id === shown.id,
    replaced: app.id !== first.current,
  }));
  return { bodies, ready, holding: shown.id !== active.id };
}
